<div>
	<p *ngIf="loginType == 1" class="wrapper has-background dark-blue has-padding">Success: your profile was created</p>
	<p *ngIf="loginType == 3" class="wrapper has-background dark-blue has-padding">Applicant Screening Dispute Request Form</p>

	<div *ngIf="(user || vendorUser) ;  else loading" class="wrapper has-padding">
    <h1 *ngIf="user"  class="bofa--heading is-1">Applicant login</h1>
    <h1 *ngIf="vendorUser"  class="bofa--heading is-1">Login</h1>
		<form [formGroup]="form" (ngSubmit)="onSubmit()">
			<p *ngIf="user">If you have trouble accessing your application, please reach out to the contact listed in your invitation
				email.</p>
			<p class="bottom-space">Required fields are followed by <abbr title="required">*</abbr>.</p>

			<p *ngIf="loginType == 2 || loginType == 3" class="bottom-space global-red">(Please note: This is the same user name and password established when you provided consent for your background check)</p>

			<div *ngIf="user">
				<mat-form-field class="flex-width max-width-400" >
					<mat-label>Username</mat-label>
					<input matInput value="{{user.email}}" disabled>
				</mat-form-field>
     		</div>

			<div *ngIf="4 == loginType">
				<mat-form-field class="flex-width max-width-400"
                  >
				  <mat-label>Username</mat-label>
				  <input matInput value="{{vendorUser.username}}" disabled>
                  <mat-error>Please enter Username</mat-error>
                </mat-form-field>
			</div>

			<div id="main-content"  (focusout)="onFocusOutMainContent($event)">
				<mat-form-field class="flex-width max-width-400">
					<mat-label id="password-label">Password</mat-label>
					<input matInput formControlName="password" type="password" required autocomplete="off" aria-labelledby="password-label" aria-required="true">
					<mat-error *ngIf="password.hasError('submittedCredentialError')">Username/Password combination is
						wrong. Please try again</mat-error>
					<mat-error *ngIf="password.hasError('required')">Please enter your password</mat-error>
				</mat-form-field>
			</div>

			<div *ngIf="user" class="is-taller mobile-flex">
				<button class="bofa--button primary large zoom-width" [disabled]="!form.valid">Login</button>
				<button type="button" [routerLink]="['/forgotPassword']" class="bofa--button secondary outlined zoom-width">I forgot my password</button>
				<button type="button" [routerLink]="['/changePassword']" class="bofa--button secondary outlined zoom-width">I want to change my password</button>
     		</div>

			<div *ngIf="vendorUser" class="is-taller mobile-flex">
				<button class="bofa--button primary large zoom-width" [disabled]="!form.valid">Login</button>
				<button type="button" [routerLink]="['/securityQuestions']" class="bofa--button secondary outlined zoom-width">I forgot my password</button>
				<button type="button" [routerLink]="['/changePassword']" class="bofa--button secondary outlined zoom-width">I want to change my password</button>
			</div>
		</form>
	</div>
</div>
<ng-template #loading>
	Loading Applicant User...
</ng-template>
